import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserIcon, CreditCardIcon, SettingsIcon, BookmarkIcon, LogOutIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
import Button from '../components/common/Button';
const Account = () => {
  const [activeTab, setActiveTab] = useState('bookings');
  // Mock user data
  const user = {
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+1 (555) 123-4567',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  };
  // Mock bookings data
  const bookings = [{
    id: 'b1',
    type: 'flight',
    reference: 'TRV-123456',
    status: 'Confirmed',
    date: '2023-08-15',
    details: 'New York (JFK) to Los Angeles (LAX)',
    price: 349
  }, {
    id: 'b2',
    type: 'hotel',
    reference: 'TRV-789012',
    status: 'Confirmed',
    date: '2023-09-20',
    details: 'Grand Luxury Resort, Los Angeles',
    price: 1793
  }, {
    id: 'b3',
    type: 'package',
    reference: 'TRV-345678',
    status: 'Completed',
    date: '2023-06-10',
    details: 'Flight + Hotel to Miami',
    price: 2150
  }];
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-516">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-517">
        <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-518">
          {/* User header */}
          <div className="bg-blue-600 p-6 sm:p-8" data-id="element-519">
            <div className="flex flex-col sm:flex-row items-center sm:items-start" data-id="element-520">
              <div className="h-24 w-24 rounded-full overflow-hidden border-4 border-white mb-4 sm:mb-0 sm:mr-6" data-id="element-521">
                <img src={user.avatar} alt={user.name} className="h-full w-full object-cover" data-id="element-522" />
              </div>
              <div className="text-center sm:text-left" data-id="element-523">
                <h1 className="text-2xl font-bold text-white" data-id="element-524">{user.name}</h1>
                <p className="text-blue-100" data-id="element-525">{user.email}</p>
                <p className="text-blue-100" data-id="element-526">{user.phone}</p>
              </div>
            </div>
          </div>
          {/* Tab navigation */}
          <div className="border-b border-gray-200" data-id="element-527">
            <nav className="flex overflow-x-auto" data-id="element-528">
              <button onClick={() => setActiveTab('bookings')} className={`py-4 px-6 text-sm font-medium whitespace-nowrap ${activeTab === 'bookings' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-529">
                My Bookings
              </button>
              <button onClick={() => setActiveTab('profile')} className={`py-4 px-6 text-sm font-medium whitespace-nowrap ${activeTab === 'profile' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-530">
                Profile Settings
              </button>
              <button onClick={() => setActiveTab('payment')} className={`py-4 px-6 text-sm font-medium whitespace-nowrap ${activeTab === 'payment' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-531">
                Payment Methods
              </button>
              <button onClick={() => setActiveTab('saved')} className={`py-4 px-6 text-sm font-medium whitespace-nowrap ${activeTab === 'saved' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-532">
                Saved Items
              </button>
            </nav>
          </div>
          {/* Tab content */}
          <div className="p-6" data-id="element-533">
            {activeTab === 'bookings' && <div data-id="element-534">
                <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-535">
                  My Bookings
                </h2>
                {bookings.length > 0 ? <div className="space-y-4" data-id="element-536">
                    {bookings.map(booking => <div key={booking.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" data-id="element-537">
                        <div className="flex flex-col md:flex-row md:justify-between md:items-center" data-id="element-538">
                          <div data-id="element-539">
                            <div className="flex items-center mb-2" data-id="element-540">
                              <span className={`inline-block w-3 h-3 rounded-full mr-2 ${booking.status === 'Confirmed' ? 'bg-green-500' : booking.status === 'Pending' ? 'bg-yellow-500' : 'bg-blue-500'}`} data-id="element-541"></span>
                              <span className="font-medium text-gray-900" data-id="element-542">
                                {booking.status}
                              </span>
                              <span className="mx-2 text-gray-300" data-id="element-543">|</span>
                              <span className="text-gray-500" data-id="element-544">
                                {booking.reference}
                              </span>
                            </div>
                            <h3 className="font-medium text-gray-900" data-id="element-545">
                              {booking.details}
                            </h3>
                            <div className="flex items-center mt-2 text-sm text-gray-500" data-id="element-546">
                              <CalendarIcon className="h-4 w-4 mr-1" data-id="element-547" />
                              {new Date(booking.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                            </div>
                          </div>
                          <div className="mt-4 md:mt-0 flex flex-col md:items-end" data-id="element-548">
                            <span className="text-lg font-bold text-blue-600" data-id="element-549">
                              ${booking.price}
                            </span>
                            <div className="mt-2 space-x-2" data-id="element-550">
                              <Button variant="outline" size="sm" data-id="element-551">
                                View Details
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>)}
                  </div> : <div className="text-center py-8" data-id="element-552">
                    <div className="mx-auto h-12 w-12 text-gray-400" data-id="element-553">
                      <CalendarIcon className="h-12 w-12" data-id="element-554" />
                    </div>
                    <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-555">
                      No bookings
                    </h3>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-556">
                      You haven't made any bookings yet.
                    </p>
                    <div className="mt-6" data-id="element-557">
                      <Link to="/" data-id="element-558">
                        <Button variant="primary" data-id="element-559">Book a Trip</Button>
                      </Link>
                    </div>
                  </div>}
              </div>}
            {activeTab === 'profile' && <div data-id="element-560">
                <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-561">
                  Profile Settings
                </h2>
                <form className="space-y-6" data-id="element-562">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-563">
                    <div data-id="element-564">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700" data-id="element-565">
                        First Name
                      </label>
                      <input type="text" id="firstName" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" defaultValue="John" data-id="element-566" />
                    </div>
                    <div data-id="element-567">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700" data-id="element-568">
                        Last Name
                      </label>
                      <input type="text" id="lastName" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" defaultValue="Doe" data-id="element-569" />
                    </div>
                    <div data-id="element-570">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-571">
                        Email Address
                      </label>
                      <input type="email" id="email" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" defaultValue={user.email} data-id="element-572" />
                    </div>
                    <div data-id="element-573">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-574">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" defaultValue={user.phone} data-id="element-575" />
                    </div>
                  </div>
                  <div data-id="element-576">
                    <h3 className="text-md font-medium text-gray-900 mb-3" data-id="element-577">
                      Change Password
                    </h3>
                    <div className="space-y-4" data-id="element-578">
                      <div data-id="element-579">
                        <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700" data-id="element-580">
                          Current Password
                        </label>
                        <input type="password" id="currentPassword" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-581" />
                      </div>
                      <div data-id="element-582">
                        <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700" data-id="element-583">
                          New Password
                        </label>
                        <input type="password" id="newPassword" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-584" />
                      </div>
                      <div data-id="element-585">
                        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700" data-id="element-586">
                          Confirm New Password
                        </label>
                        <input type="password" id="confirmPassword" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-587" />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end" data-id="element-588">
                    <Button variant="primary" type="submit" data-id="element-589">
                      Save Changes
                    </Button>
                  </div>
                </form>
              </div>}
            {activeTab === 'payment' && <div data-id="element-590">
                <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-591">
                  Payment Methods
                </h2>
                <div className="space-y-4" data-id="element-592">
                  <div className="border border-gray-200 rounded-lg p-4" data-id="element-593">
                    <div className="flex justify-between items-center" data-id="element-594">
                      <div className="flex items-center" data-id="element-595">
                        <div className="bg-blue-100 rounded-md p-2 mr-4" data-id="element-596">
                          <CreditCardIcon className="h-6 w-6 text-blue-600" data-id="element-597" />
                        </div>
                        <div data-id="element-598">
                          <p className="font-medium text-gray-900" data-id="element-599">
                            Visa ending in 4242
                          </p>
                          <p className="text-sm text-gray-500" data-id="element-600">
                            Expires 12/2025
                          </p>
                        </div>
                      </div>
                      <div data-id="element-601">
                        <Button variant="outline" size="sm" data-id="element-602">
                          Edit
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4 border-dashed text-center" data-id="element-603">
                    <Button variant="secondary" data-id="element-604">Add New Payment Method</Button>
                  </div>
                </div>
              </div>}
            {activeTab === 'saved' && <div data-id="element-605">
                <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-606">
                  Saved Items
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-607">
                  <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-608">
                    <img src="https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Saved hotel" className="w-full h-40 object-cover" data-id="element-609" />
                    <div className="p-4" data-id="element-610">
                      <h3 className="font-medium text-gray-900" data-id="element-611">
                        Seaside Family Resort
                      </h3>
                      <div className="flex items-center mt-1 text-sm text-gray-500" data-id="element-612">
                        <MapPinIcon className="h-4 w-4 mr-1" data-id="element-613" />
                        <span data-id="element-614">Los Angeles, USA</span>
                      </div>
                      <div className="mt-4 flex justify-between items-center" data-id="element-615">
                        <span className="font-bold text-blue-600" data-id="element-616">
                          $249/night
                        </span>
                        <Button variant="primary" size="sm" data-id="element-617">
                          View Details
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-618">
                    <img src="https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80" alt="Saved destination" className="w-full h-40 object-cover" data-id="element-619" />
                    <div className="p-4" data-id="element-620">
                      <h3 className="font-medium text-gray-900" data-id="element-621">
                        Paris City Break
                      </h3>
                      <div className="flex items-center mt-1 text-sm text-gray-500" data-id="element-622">
                        <MapPinIcon className="h-4 w-4 mr-1" data-id="element-623" />
                        <span data-id="element-624">Paris, France</span>
                      </div>
                      <div className="mt-4 flex justify-between items-center" data-id="element-625">
                        <span className="font-bold text-blue-600" data-id="element-626">$699</span>
                        <Button variant="primary" size="sm" data-id="element-627">
                          View Details
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};
export default Account;